import { render, staticRenderFns } from "./Chold.vue?vue&type=template&id=33480a54&"
import script from "./Chold.vue?vue&type=script&lang=js&"
export * from "./Chold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports